import { type ReactNode, type RefObject } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { useSectionView } from '../hooks/useSectionView';

interface SectionTrackerProps {
  sectionName: string;
  children: ReactNode;
}

export default function SectionTracker({ sectionName, children }: SectionTrackerProps) {
  const ref = useSectionView(sectionName) as RefObject<HTMLDivElement>;
  return (
    <ErrorBoundary sectionName={sectionName}>
      <div ref={ref}>{children}</div>
    </ErrorBoundary>
  );
}
